import { render, staticRenderFns } from "./Architects.vue?vue&type=template&id=1bd3169a"
import script from "./Architects.vue?vue&type=script&lang=js"
export * from "./Architects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports